<template>
    <div class="server-detail-footer" v-show="!(platform === 0 && jobId)">
        <div class="count-panel">
            <span class="count">
                工资：
                <span v-if="count && count != '面议' && count != 'undefined' && count != 'null' && count != ''">
                    <span class="count-integer">{{parseInt(count)}}{{unit}}</span> <span class="count-decimal">起</span>
                </span>
                <span v-else>{{count}}</span>
            </span>
        </div>
        <span class="handle" @click="handle" v-if="platform == 3">请客户评价</span>
        <span class="handle" @click="handle" v-if="platform == 0 && !jobId">预约下单</span>
        <a class="handle variant3" :href="'tel:'+(telephoneNum)" v-if="platform==2 && telephoneNum && jobId && fromPage==4 && handleType!=2">拨打电话</a>
        <a class="handle variant3 additional" :href="'tel:'+(telephoneNum)" v-else-if="platform==2 && telephoneNum">拨打电话</a>
        <span class="handle variant1" @click="handle" v-if="platform==2 && jobId && fromPage==4 && handleType==2">邀请面试</span>
        <!-- <span class="handle variant1" @click="handle" v-if="platform==2 && jobId && fromPage==4 && handleType!=2">不可邀请</span> -->
        <span class="handle variant1" @click="handle" v-if="platform==2 && !jobId && fromPage!=4 && handleType!=2">匹配订单</span>
        <span class="handle variant2" @click="handle" v-if="platform==2 && jobId && fromPage!=4 && handleType!=2">推荐</span>
    </div>
</template>
<script>
    export default {
        props: {
            count: { //工资
                type: String|Number,
                default: "面议"
            },
            unit: { //工资单位
                type: String,
                default: ""
            },
            platform: { //平台: 0:用户端(默认),2:客户经理端
                type: Number,
                default: 0
            },
            //上一页面: 0:不确认(默认),1:用户端服务师列表,2:客户经理端服务师列表,3:服务师端邀请评价,4:客户经理端代下单发单列表
            fromPage: {
                type: Number,
                default: 0
            },
            jobId: { //订单Id
              type: Number,
              default: 0
            },
            handleType: { //操作类型: 0:不确认(默认),2:发送邀请
                type: Number,
                default: 0
            },
            telephoneNum: { //电话号码
                type: String|Number,
                default: ""
            },
        },
        data(){
            return {

            }
        },
        mounted(){

        },
        methods:{
            //是否为数字
            isRealNum(val){
                //方法一：
                // isNaN()函数 把空串 空格 以及NUll 按照0来处理 所以先去除
                // if(val === "" || val ==null){
                //     return false;
                // }
                // if(!isNaN(val)){
                //     return true;
                // }else{
                //     return false;
                // }
                //方法二：
                if(typeof(val) == "Number"){
                    return true;
                } else {
                    return false;
                }
            },
            //提交按钮
            handle(){
                this.$emit("handle");
            }
        }
    }
</script>
<style>
    .server-detail-footer{
        flex: 0 0 auto;
        width: 96%;
        height: 0.94rem;
        padding-left: 4%;
        overflow: hidden;
        background-color: #ffffff;
        border-top: 1px solid #9fa0a0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        position: relative;
        z-index: 9;
    }
    .server-detail-footer .count-panel{
        flex: 1 1 auto;
        margin-right: 0.4rem;
    }
    .server-detail-footer .count{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        position: relative;
        font-size: 0.3rem;
        color: #ea531a;
        line-height: 0.94rem;
        font-weight: bold;
    }
    .server-detail-footer .count-unit{
        display: inline-block;
        margin-right: 0.02rem;
        font-size: 0.46rem;
    }
    .server-detail-footer .count-integer{
        /* font-size: 0.3rem; */
        font-weight: bold;
    }
    .server-detail-footer .count-decimal{
        font-size: 0.24rem;
    }
    .server-detail-footer .count-tag-discount{
        display: inline-block;
        position: absolute;
        left: 100%;
        top: 0.05rem;
        min-width: 0.56rem;
        padding: 0 0.04rem;
        background-color: #676568;
        border-radius: 0.04rem;
        text-align: center;
        font-size: 0.24rem;
        color: #ffffff;
        line-height: 0.34rem;
    }
    .server-detail-footer .handle{
        /* flex: 0 0 auto; */
        width: 36%;
        height: 100%;
        background-color: #0a8593;
        text-align: center;
        font-size: 0.3rem;
        color: #ffffff;
        font-weight: bold;
        /* display: flex;
        flex-direction: row;
        justify-content: center; */
        display: block;
        position: absolute;
        right: 0;
        top: 0;
        line-height: 0.94rem;
    }
    .server-detail-footer .handle.variant1{
        width: 26%;
        background-color: #0a8593;
    }
    .server-detail-footer .handle.variant2{
        width: 26%;
        background-color: #e7726f;
    }
    .server-detail-footer .handle.variant3{
        width: 26%;
        background-color: #14ae67;
    }
    .server-detail-footer .handle.additional{
        right: 26%;
    }
    .server-detail-footer .handle.disabled{
        background-color: #999999;
    }
</style>



// WEBPACK FOOTER //
// src/shared/components/server/server-detail-footer.vue